module.exports = __webpack_public_path__ + "img/20210213_183648.fc4d9b9b.jpg";